import { FlowPage } from 'src/lib/flow/FlowPage';
import { DetailReviewElement, FlowQuestion } from 'src/lib/flow/FlowQuestion';

import basicDataPage, { hasOnlyValidBasicDataAnswers } from './basicDataPage';

const reviewHomeDetailsPage: FlowPage = {
  slug: () => 'basic-data-review',
  title: () => 'Confirm your home details',
  subtitle: () =>
    'This info is available to the public. You can edit these details if you’ve made any updates to your home.',
  subtitleElement: (experimentFlags) => {
    if (experimentFlags.experimentFlags.addressEntryConfirmation === 'treatment') {
      return;
    }
    return {
      type: 'element',
      key: 'address_map',
      component: 'address_map',
    };
  },
  isEnabled: hasOnlyValidBasicDataAnswers,
  autoAdvance: () => false,
  nextText: () => 'Confirm',
  secondaryAction: () => ({
    label: 'Edit',
    answerSet: [{ key: 'seller.edit_home_details', answer: true }],
  }),
  questions: (ctx): Array<FlowQuestion> => {
    const questions = basicDataPage.questions(ctx);
    return questions
      .map((question) => {
        if (question.type == 'dropdown_select' || question.type == 'integer') {
          const { key, label, hidden, helperText } = question;
          const element: DetailReviewElement = {
            type: 'element',
            component: 'detail_review',
            key,
            hidden,
            props: {
              label,
              helperText,
              suffix: 'suffix' in question ? question.suffix : undefined,
              options: 'options' in question ? question.options : undefined,
              showCommas: 'showCommas' in question ? question.showCommas : undefined,
            },
          };
          return element;
        }
        return null;
      })
      .filter((question) => question !== null) as FlowQuestion[];
  },
};

export default reviewHomeDetailsPage;
